import React from 'react';
import PageShell from '../../components/PageShell';
import { useP } from '../../i18n/useP';
import './BusinessPlanPage.css';

/* BUSINESS PLAN EN SUSPENS (décision Olivier, 2026-09-30) : la section reste
   au menu, marquée « bientôt », mais la table est MASQUÉE. Elle affichait des
   chiffres calculés sur des données encore incomplètes, qu'un client aurait lus
   comme vrais. À la place, un encart et une esquisse grisée, SANS AUCUN
   CHIFFRE. La table (compte de résultat et bilan au 31.12, un exercice par
   colonne, lus du serveur `/financials/business-plan`) vit dans l'historique,
   commit fe59c32b7 ; la route serveur reste en place. */
export default function BusinessPlanPage() {
  const p = useP();
  const bars = [38, 46, 52, 61, 70];
  return (
    <PageShell kind="report" title={p('Business plan')}>
      <div className="bpw">
        <div className="bpw-msg">
          <div className="bpw-tag">{p('Bientôt')}</div>
          <h2>{p('Business plan : en développement, disponible prochainement')}</h2>
        </div>
        <svg className="bpw-sketch" viewBox="0 0 520 220" role="img" aria-label={p('Esquisse')}>
          <line x1="30" y1="190" x2="500" y2="190" />
          {bars.map((h, i) => (
            <rect key={i} x={60 + i * 90} y={190 - h * 2.4} width="44" height={h * 2.4} rx="3" />
          ))}
          <polyline points={bars.map((h, i) => `${82 + i * 90},${150 - h * 1.6}`).join(' ')} />
          {bars.map((h, i) => <circle key={i} cx={82 + i * 90} cy={150 - h * 1.6} r="4" />)}
        </svg>
      </div>
    </PageShell>
  );
}
